export default {
  id: 211,
  title: 'Target #211 - CSS Weekly',
  url: 'https://cssbattle.dev/play/211',
  colors: ['#9B8170', '#FFFFFF'],
  solution:
    '<p a><p b><p c><p d><p e><p f><style>p[a],p[b]{top:90.5;width:80;height:80;border-radius:1in 1in 0;rotate:45deg}p[c],p[d]{width:140;height:100;border-radius:1in 1in 0 0;box-shadow:inset 0 0 0 20px #fff;bottom:40}p[a],p[b],p[c],p[d]{box-shadow:inset 0 0 0 20px #fff}p[c],p[d],p[e]{bottom:40}p[e],p[f]{width:20;background:#9b8170}body,p[c],p[d],p[e],p[f]{background:#9b8170}p[a],p[b],p[f]{rotate:45deg}p{position:fixed;margin:0}p[a]{left:110}p[b]{left:210}p[c]{right:80}p[d]{left:80}p[e]{left:180;height:20}p[f]{top:156.5;left:265;height:40',
}
